import { render, staticRenderFns } from "./list-item-parque-compact.vue?vue&type=template&id=2d0b4528"
import script from "./list-item-parque-compact.vue?vue&type=script&lang=js"
export * from "./list-item-parque-compact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports